
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_1xsq7_17",
  "arrow": "awsui_arrow_18eso_1xsq7_17",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_1xsq7_73",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_1xsq7_73",
  "has-caret": "awsui_has-caret_18eso_1xsq7_109",
  "placeholder": "awsui_placeholder_18eso_1xsq7_112",
  "pressed": "awsui_pressed_18eso_1xsq7_128",
  "disabled": "awsui_disabled_18eso_1xsq7_134",
  "in-filtering-token": "awsui_in-filtering-token_18eso_1xsq7_73",
  "readonly": "awsui_readonly_18eso_1xsq7_155",
  "grouped": "awsui_grouped_18eso_1xsq7_167",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_18eso_1xsq7_181",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_18eso_1xsq7_185",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_18eso_1xsq7_191",
  "grouped-vertical-first": "awsui_grouped-vertical-first_18eso_1xsq7_195",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_18eso_1xsq7_199",
  "grouped-vertical-last": "awsui_grouped-vertical-last_18eso_1xsq7_205",
  "grouped-with-action": "awsui_grouped-with-action_18eso_1xsq7_209",
  "invalid": "awsui_invalid_18eso_1xsq7_222",
  "warning": "awsui_warning_18eso_1xsq7_231",
  "custom-option": "awsui_custom-option_18eso_1xsq7_240",
  "inline-tokens": "awsui_inline-tokens_18eso_1xsq7_245"
};
  